import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import moment from 'moment';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorLog } from 'src/app/Model/Common/error-log';
import { Subscription } from 'rxjs';
import { Constant } from 'src/app/Common/constant';
import { APIFactoryEndPoints } from 'src/app/Model/Common/apifactory-end-points';
import { ShippingManagerService } from 'src/app/Service/Shipping/shipping-manager.service';
import { LocalStorageService } from 'src/app/Model/Common/LocalStorageService';
import { ToastrService } from 'src/app/Service/Common/toastr.service';

@Component({
  selector: 'app-mobile-number-verification-dialog',
  templateUrl: './mobile-number-verification-dialog.component.html',
  styleUrls: ['./mobile-number-verification-dialog.component.css']
})
export class MobileNumberVerificationDialogComponent implements OnInit, OnDestroy {

  mobileNo: string;
  loginCompanyCode: number

  randomString: string = "";
  showHideSendOtpDiv: boolean = true;
  showHideOtpDiv: boolean = false;

  errorLog: ErrorLog = new ErrorLog();

  //Subscription
  private whatsAppOptInByMobileNoSubscription: Subscription;
  private whatsAppOTPByMobileNoSubscription: Subscription;
  private insertErrorLogSubscription: Subscription;
  containerService: any;

  constructor(
    private dialogRef: MatDialogRef<MobileNumberVerificationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private constant: Constant,
    public dialog: MatDialog,
    private apiFactory: APIFactoryEndPoints,
    private shippingManagerService: ShippingManagerService,
    public persistenceService: LocalStorageService,
    private toastService: ToastrService

  ) {
    // dialogRef.disableClose = true;
    this.mobileNo = dialogData.data;
    this.loginCompanyCode = dialogData.companyCode;
    console.log(this.loginCompanyCode);
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    if (this.whatsAppOptInByMobileNoSubscription !== undefined)
      this.whatsAppOptInByMobileNoSubscription.unsubscribe();

    if (this.whatsAppOTPByMobileNoSubscription !== undefined)
      this.whatsAppOTPByMobileNoSubscription.unsubscribe();

    if (this.insertErrorLogSubscription !== undefined)
      this.insertErrorLogSubscription.unsubscribe();
  }

  onSendOtpClick() {
    let otp = Math.random();
  }

  generateRandomOtp() {
    var s = [];
    var hexDigits = "0123456789";
    for (var i = 0; i < 6; i++) {
      let num: number = Math.floor(1 + Math.random() * 9);
      s[i] = hexDigits.substr(num, 1);
    }
    var uuid = s.join("");
    return uuid;
  }

  sendOtpClick() {
    this.randomString = this.generateRandomOtp();

    this.showHideSendOtpDiv = false;
    this.showHideOtpDiv = true;
    console.log(this.randomString);
    this.whatsAppOptInByMobileNoSubscription = this.shippingManagerService.sendWhatsAppOptInByMobileNo(this.apiFactory.sendWhatsAppOptInByMobileNo, this.loginCompanyCode, this.mobileNo).subscribe((data: any) => {
      if (data) {
        this.whatsAppOTPByMobileNoSubscription = this.shippingManagerService.sendWhatsAppOTPByMobileNo(this.apiFactory.sendWhatsAppOTPByMobileNo, this.loginCompanyCode, this.mobileNo, this.randomString).subscribe((data: any) => {
          if (data) {
            this.showHideSendOtpDiv = false;
            this.showHideOtpDiv = true;
            this.toastService.clearAllToast();
            this.toastService.showSuccessToast(this.constant.OTPToast);
          }
        },
          (error: HttpErrorResponse) => {
            this.insertErrorLog("sendOtpClick", error);
          });
      }
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("sendOtpClick", error);
      });
  }

  reSendOtpClick() {
    console.log(this.randomString);
    this.whatsAppOptInByMobileNoSubscription = this.shippingManagerService.sendWhatsAppOTPByMobileNo(this.apiFactory.sendWhatsAppOTPByMobileNo, this.loginCompanyCode, this.mobileNo, this.randomString).subscribe((data: any) => {
      if (data) {
        this.toastService.clearAllToast();
        this.toastService.showSuccessToast(this.constant.OTPresentToast);
      }
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("reSendOtpClick", error);
      });
  }

  checkOtp(value: string) {
    console.log(this.randomString);
    if (value.length == 6) {
      if (this.randomString == value) {
        this.showHideOtpDiv = false;
        this.toastService.clearAllToast();
        this.toastService.showSuccessToast(this.constant.OTPverfiedToast);
        this.dialogRef.close({ verified: true, mobileNo: this.mobileNo });
      } else {
        this.showHideOtpDiv = true;
        this.toastService.clearAllToast();
        this.toastService.showErrorToast(this.constant.invalidOTPToast);
      }
    }
  }

  insertErrorLog(errorMethod: string, error: HttpErrorResponse) {
    this.errorLog.userId = this.persistenceService.get('userId');
    this.errorLog.dateAndTime = moment(new Date()).format(this.constant.dateTimeFormatForDBServer);
    this.errorLog.moduleName = "Verify WhatsApp No";
    this.errorLog.errorMethod = errorMethod;
    this.errorLog.platform = "Web";
    if (error?.error?.message || error?.error?.message != '')
      this.errorLog.errorDetails = error.error.message;
    else
      this.errorLog.errorDetails = error.message;

    // this.insertErrorLogSubscription = this.containerService.insertErrorLog(this.apiFactory.insertErrorLog, this.errorLog).subscribe((data: any) => {
    // });
  }

}
